<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="1"
      loader="bars"
    ></loading>
    <div class="container-scroller" style="background: #f9fafb">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div
          class="vh-100 content-wrapper auth-wrapper d-flex no-block d-flex justify-content-center align-items-center auth auth-img-bg"
        >
          <div class="row-login flex-grow">
            <div class="col-12">
              <div class="brand-logo" align="center">
                <img
                  src="../../assets/images/logo.png"
                  alt="logo"
                  height="45"
                />
              </div>
              <div class="auth-form-transparent">
                <div align="center">
                  <h5 class="pt-3">{{ $t("Reset Password") }}</h5>
                </div>
                <div
                  v-if="mssg"
                  align="center"
                  class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
                >
                  <p class="alert-close mb-0">
                    {{ mssg }}
                  </p>
                </div>
                <div
                  v-else-if="Errormssg"
                  align="center"
                  class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
                >
                  <p class="alert-close mb-0">
                    {{ Errormssg }}
                  </p>
                </div>
                <form v-if="validToken" @submit.prevent="onSubmit" class="pt-3">
                  <div class="form-group">
                    <label for="InputPassword">{{ $t("New Password") }}</label>
                    <div class="form-group">
                      <input
                        :type="show === true ? 'text' : 'password'"
                        class="form-control"
                        id="InputPassword"
                        required="required"
                        v-model="new_password"
                        name="password"
                      />
                      <div
                        class="position-absolute mb-4 mr-2"
                        style="cursor: pointer; top: 0.7rem; right: 0.5rem;"
                      >
                        <div :key="'show'" @click="show = !show" v-if="show">
                          <i class="fas fa-eye"></i>
                        </div>
                        <div :key="'!show'" @click="show = !show" v-else>
                          <i class="far fa-eye-slash"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="Confirm_InputPassword">{{
                      $t("Confirm Password")
                    }}</label>
                    <div class="form-group mb-2">
                      <input
                        :type="show2 === true ? 'text' : 'password'"
                        class="form-control"
                        id="Confirm_InputPassword"
                        required="required"
                        v-model="confirm_password"
                        name="password"
                      />
                      <p class="small gray4">
                        {{
                          $t(
                            "Strong passwords should be 8 characters long with a mix of upper case, lower case, and special characters"
                          )
                        }}
                      </p>
                    </div>
                    <div
                      class="position-absolute mb-4 mr-2"
                      style="cursor: pointer; top: 2.4rem; right: 0.5rem;"
                    >
                      <div :key="'show2'" @click="show2 = !show2" v-if="show2">
                        <i class="fas fa-eye"></i>
                      </div>
                      <div :key="'!show'" @click="show2 = !show2" v-else>
                        <i class="far fa-eye-slash"></i>
                      </div>
                    </div>
                    <p v-if="Errorpass" class="small text-error p-1 mb-0">
                      {{ Errorpass }}
                    </p>
                    <div
                      style="height: 0.25rem; border-radius: 5px"
                      :class="getClass()"
                    ></div>
                  </div>

                  <div class="my-3" align="center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      :disabled="this.scorePassword < 6"
                    >
                      {{ $t("Submit") }}
                    </button>
                  </div>
                </form>
              </div>
              <div v-if="!validToken" class="text-center pt-3">
                <p>
                  <router-link to="/forgotpassword" class="btn-link"
                    >{{ $t("reset-password-again") }}?</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Login",
  data() {
    return {
      new_password: "",
      confirm_password: "",
      validToken: false,
      Errorpass: "",
      mssg: "",
      Errormssg: "",
      isLoading: true,
      fullPage: true,
      show: false,
      show2: false,
    };
  },
  mounted() {
    this.loadReset({ token: this.$route.params.token })
      .then(() => {
        this.validToken = true;
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        this.Errormssg = error.response.data.message;
        // error.response can be null
        if (error.response) {
          console.error(error.response.data.message);
        }
      });
  },
  components: {
    Loading,
  },
  computed: {
    scorePassword() {
      let score = 1;
      let password = "";
      for (let i = 0; i < this.new_password.length; i++) {
        if (this.new_password[i] === this.confirm_password[i]) {
          password += this.new_password[i];
        } else {
          break;
        }
      }
      // //console.log(password, "password")
      // //console.log(password.length)
      if (password === "") return score;
      if (password.length >= 8) {
        score++;
      }
      let variations = [
        /\d/.test(password),
        /[a-z]/.test(password),
        /[A-Z]/.test(password),
        /\W/.test(password),
      ];
      for (let i = 0; i < variations.length; i++) {
        if (variations[i] === true) {
          score++;
        }
      }
      // //console.log(score, "score");
      return parseInt(score);
    },
  },
  methods: {
    ...mapActions(["changePass", "loadReset"]),
    getClass() {
      console.log(this.scorePassword);
      if (this.scorePassword < 2) return "bg-gray2 w-100";
      if (this.scorePassword == 2) return "bg-danger w-25";
      else if (this.scorePassword == 3 || this.scorePassword == 4)
        return "bg-orange w-50";
      else if (this.scorePassword == 5) return "bg-warning w-75";
      else if (this.scorePassword == 6) return "bg-success w-100";
    },
    onSubmit() {
      this.Errorpass = "";
      //console.log(this.scorePassword, "score")
      if (this.new_password !== this.confirm_password) {
        this.Errorpass = this.$t("passwords_do_not_match");
      } else {
        if (this.new_password.length < 8) {
          this.Errorpass = this.$t("password_min_length_error");
        } else if (this.scorePassword < 5) {
          this.Errorpass = this.$t("password_strength_error");
        } else {
          this.isLoading = true;
          const user = {
            password: this.new_password,
          };
          this.changePass({ token: this.$route.params.token, user })
            .then((res) => {
              this.isLoading = false;
              if (res.data.success) {
                this.mssg = res.data.message;
                setTimeout(() => {
                  this.isLoading = true;
                }, 1000);
                setTimeout(() => {
                  this.$router.push("/login");
                }, 4000);
              }
            })
            .catch((error) => {
              this.isLoading = false;
              this.Errormssg = error.response.data.message;
              // error.response can be null
              if (error.response) {
                console.error(error.response.data.message);
              }
            });
        }
      }
    },
  },
};
</script>

<i18n>
  {
    "en": {
      "Reset Password": "Reset Password",
      "New Password": "New Password",
      "Confirm Password": "Confirm Password",
      "Strong passwords should be 8 characters long with a mix of upper case, lower case, and special characters": "Strong passwords should be 8 characters long with a mix of upper case, lower case, and special characters",
      "Submit": "Submit",
      "reset-password-again": "Reset your password again?",
      "passwords_do_not_match": "Passwords do not match",
    "password_min_length_error": "Password must be at least 8 characters long",
    "password_strength_error": "Password must contain at least one uppercase, one lowercase, and one special character"
    },
    "fr": {
      "Reset Password": "Réinitialiser le mot de passe",
      "New Password": "Nouveau mot de passe",
      "Confirm Password": "Confirmez le mot de passe",
      "Strong passwords should be 8 characters long with a mix of upper case, lower case, and special characters": "Les mots de passe forts doivent comporter 8 caractères avec un mélange de majuscules, de minuscules et de caractères spéciaux",
      "Submit": "Soumettre",
      "reset-password-again": "Réinitialiser votre mot de passe à nouveau?",
      "passwords_do_not_match": "Les mots de passe ne correspondent pas",
    "password_min_length_error": "Le mot de passe doit contenir au moins 8 caractères",
    "password_strength_error": "Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule et un caractère spécial"
    },
    "sw": {
      "Reset Password": "Futa nenosiri",
      "New Password": "Nenosiri Mpya",
      "Confirm Password": "Thibitisha Nenosiri",
      "Strong passwords should be 8 characters long with a mix of upper case, lower case, and special characters": "Nenosiri zenye nguvu lazima ziwe na herufi 8 zenye mchanganyiko wa herufi kubwa, ndogo, na ishara maalum",
      "Submit": "Wasilisha",
      "reset-password-again": "Fanya upya nenosiri lako tena?",
      "passwords_do_not_match": "Nywila hazilingani",
    "password_min_length_error": "Nywila lazima iwe na angalau herufi 8",
    "password_strength_error": "Nywila lazima iwe na angalau herufi moja kubwa, moja ndogo na kisimbio maalum"
    }
  }
  </i18n>
